function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import Layout from '@4c/layout';
import styled from 'astroturf'
import classNames from 'classnames';
import React from 'react';
import BootstrapModalManager from 'react-bootstrap/BootstrapModalManager';
import BsModal from 'react-bootstrap/Modal';
import Heading from './Heading';
import { provideTheme } from './ThemeContext'; // Allow react-overlays <Modal>s to use the same modal manager.

export const modalManager = new BootstrapModalManager();
const styles = require('./Modal-styles.module.scss');
const ModalDialog = React.forwardRef((props, ref) => React.createElement("div", {
  className: styles.modal
}, React.createElement("div", {
  className: styles.spacerTop
}), React.createElement(BsModal.Dialog, _extends({
  ref: ref
}, props)), React.createElement("div", {
  className: styles.spacerBottom
})));
const defaultProps = {
  backdrop: 'static',
  scrollable: true
};
const Modal = React.forwardRef(({
  className,
  ...props
}, ref) => React.createElement(BsModal, _extends({
  ref: ref
}, props, {
  manager: modalManager,
  backdropClassName: styles.backdrop,
  dialogAs: ModalDialog,
  className: classNames(className, styles.modal)
})));
const ModalHeader = /*#__PURE__*/styled(BsModal.Header, null, {
  displayName: "ModalHeader",
  styles: require("./Modal-ModalHeader.module.scss"),
  attrs: null,
  vars: []
});
const ModalTitle = /*#__PURE__*/styled(BsModal.Title, null, {
  displayName: "ModalTitle",
  styles: require("./Modal-ModalTitle.module.scss"),
  attrs: props => ({ ...props,
    as: Heading,
    level: 2
  }),
  vars: []
});
const ModalBody = provideTheme('light')(BsModal.Body);
const ModalFooter = provideTheme('light')(/*#__PURE__*/styled(BsModal.Footer, null, {
  displayName: "ModalFooter",
  styles: require("./Modal-ModalFooter.module.scss"),
  attrs: null,
  vars: []
}));

function ModalButtonGroup({
  children,
  ...props
}) {
  return React.createElement(Layout, _extends({
    reverse: true,
    justify: "space-between",
    grow: true
  }, props), children);
}

Modal.Header = ModalHeader;
Modal.Title = ModalTitle;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.ButtonGroup = ModalButtonGroup;
Modal.defaultProps = defaultProps;
/** @component */

export default Modal;